/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconPlan/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconPlan({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconPlan",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 20,
  height = 20,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#E0A93D"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconPlan.Svg"
  data-view-path={viewPath}
 viewBox="0 0 20 20"
 style={{'--as-1-IXM9': alignSelf,'--mt-2-IXM9': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-IXM9': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-IXM9': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-IXM9': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-IXM9': opacity,'--w-10-IXM9': typeof width === 'number' ? `${width}px` : width,'--h-11-IXM9': typeof height === 'number' ? `${height}px` : height,'--f-12-IXM9': fill,'--a-7-IXM9': isAnimated ? animation : "none",'--sd-8-IXM9': isAnimated ? strokeDashoffset : 0,'--sd-9-IXM9': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconPlan.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M3.17 3.97c.302-.3.71-.47 1.137-.47h8.572a1.607 1.607 0 011.607 1.607v5.903a4.988 4.988 0 00-1.607-.278c-.636 0-1.233.136-1.769.336a3.167 3.167 0 00-5.685 1.922c0 .175.142.317.317.317h2.12l-.03.029a2.77 2.77 0 00-.803 1.95H4.307A1.607 1.607 0 012.7 13.679V5.107c0-.426.17-.835.47-1.136zm7.323 3.007a1.9 1.9 0 11-3.8 0 1.9 1.9 0 013.8 0zm2.386 5.094c-.879 0-1.714.372-2.4.81a9.975 9.975 0 00-1.692 1.394 1.43 1.43 0 000 2.021c.405.412.998.953 1.692 1.395.686.437 1.521.809 2.4.809.878 0 1.713-.372 2.4-.809a9.987 9.987 0 001.692-1.395 1.43 1.43 0 000-2.02 9.978 9.978 0 00-1.693-1.396c-.686-.437-1.521-.809-2.4-.809zm1.339 3.215a1.34 1.34 0 11-2.679 0 1.34 1.34 0 012.679 0z"
 style={{'--f-12-IXM9': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}